// src/utils/logger.js
import { DEBUG } from '../config/constants';

export const log = {
	debug: (...args) => DEBUG && console.debug('[Auth Debug]:', ...args),
	info: (...args) => console.log('[Auth Info]:', ...args),
	warn: (...args) => console.warn('[Auth Warning]:', ...args),
	error: (...args) => console.error('[Auth Error]:', ...args),
	group: label => DEBUG && console.group(label),
	groupEnd: () => DEBUG && console.groupEnd()
};
